module.exports = __webpack_public_path__ + "img/24.7de885ea.jpg";